/**
 * F&B 입점 업체 서비스
 */

import apiClient from './api';
import {
  FnbVendor,
  FnbVendorFilter,
  FnbVendorListResponse,
  FnbVendorSales,
} from '../types/fnb';

export const fnbService = {
  /**
   * F&B 업체 목록 조회
   */
  async getVendors(filter: FnbVendorFilter = {}): Promise<FnbVendorListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.vendor_type) params.append('vendor_type', filter.vendor_type);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: FnbVendorListResponse }>(`/admin/fnb/vendors?${params.toString()}`);
    // return response.data.data;

    return {
      vendors: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * F&B 업체 상세 조회
   */
  async getVendor(id: number): Promise<FnbVendor> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * F&B 업체 등록
   */
  async createVendor(data: Partial<FnbVendor>): Promise<FnbVendor> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * F&B 업체 수정
   */
  async updateVendor(id: number, data: Partial<FnbVendor>): Promise<FnbVendor> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * F&B 업체 삭제
   */
  async deleteVendor(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * F&B 업체 매출 조회
   */
  async getVendorSales(
    vendorId: number,
    periodStart: string,
    periodEnd: string
  ): Promise<FnbVendorSales> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },
};

